import type { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import type { IServiceProviderManualPaymentDateLineDTO } from '../../../../../../features/salesOrder/types';

export type ProviderPaymentDateServiceSlice = {
	automaticProviderPaymentDateCalculation?: boolean | null;
	providerManualPaymentDateLines?: IServiceProviderManualPaymentDateLineDTO[] | null;
};

export type ProviderPaymentDateFormSlice = {
	automaticProviderPaymentDateCalculation?: boolean | null;
	providerManualPaymentDateLines?: IServiceProviderManualPaymentDateLineDTO[] | null;
};

export const normalizeProviderManualPaymentDateLines = (
	lines: IServiceProviderManualPaymentDateLineDTO[] | null | undefined,
): IServiceProviderManualPaymentDateLineDTO[] =>
	(lines ?? []).map((l) => ({
		id: l.id ?? null,
		paymentDate: l.paymentDate ?? '',
		amount: l.amount ?? null,
		observation: l.observation ?? '',
	}));

export const hydrateProviderPaymentDateFormFields = (
	setValue: UseFormSetValue<any>,
	service: ProviderPaymentDateServiceSlice,
): void => {
	setValue('automaticProviderPaymentDateCalculation', service.automaticProviderPaymentDateCalculation === true, {
		shouldDirty: false,
		shouldTouch: false,
		shouldValidate: false,
	});

	setValue(
		'providerManualPaymentDateLines',
		normalizeProviderManualPaymentDateLines(service.providerManualPaymentDateLines),
		{
			shouldDirty: false,
			shouldTouch: false,
			shouldValidate: false,
		},
	);
};

/** Garantiza campos exigidos por el PUT aunque RHF los omita tras reset(). */
export const applyProviderPaymentDateFieldsForPut = <T extends Record<string, unknown>>(
	payload: T,
	options: {
		formData?: ProviderPaymentDateFormSlice;
		service?: ProviderPaymentDateServiceSlice;
		getValues?: UseFormGetValues<any>;
	},
): T => {
	const fromGetValues = options.getValues
		? {
				automaticProviderPaymentDateCalculation: options.getValues('automaticProviderPaymentDateCalculation'),
				providerManualPaymentDateLines: options.getValues('providerManualPaymentDateLines'),
		  }
		: undefined;

	const automaticRaw =
		options.formData?.automaticProviderPaymentDateCalculation ??
		fromGetValues?.automaticProviderPaymentDateCalculation ??
		options.service?.automaticProviderPaymentDateCalculation;

	payload.automaticProviderPaymentDateCalculation = automaticRaw !== false;

	const linesRaw =
		options.formData?.providerManualPaymentDateLines ??
		fromGetValues?.providerManualPaymentDateLines ??
		options.service?.providerManualPaymentDateLines;

	payload.providerManualPaymentDateLines = Array.isArray(linesRaw)
		? normalizeProviderManualPaymentDateLines(linesRaw)
		: [];

	return payload;
};
